import { injectable } from 'inversify';

export class AdmissionIdAndHash {
  public lastAdmissionIdFromChain: string = '';
  public hash: string = '';
}

class ImportCacheDTO {
  constructor(public patientKey: string, public admissionIdAndHash: AdmissionIdAndHash) { }
}

export type ImportCache = Map<string, AdmissionIdAndHash>;

@injectable()
export class ImportHashCacheStorage {
  protected storage = window.localStorage;
  protected cache: ImportCache = new Map<string, AdmissionIdAndHash>();
  protected STORAGE_ITEM_KEY = 'ImportHashCacheStorage';

  constructor() {
    this.cache = this.getCache();
    if (!this.storage.getItem(this.STORAGE_ITEM_KEY)) {
      this.storage.setItem(this.STORAGE_ITEM_KEY, JSON.stringify(this.transformMapToArray()));
    }
  }

  async save(patientKey: string, admissionIdAndHash: AdmissionIdAndHash) {
    this.cache.set(patientKey, admissionIdAndHash);
    this.storage.setItem(this.STORAGE_ITEM_KEY, JSON.stringify(this.transformMapToArray()));
    return Promise.resolve();
  }

  protected transformMapToArray(): Array<ImportCacheDTO> {
    const temporaryCacheDTOArray: Array<ImportCacheDTO> = new Array<ImportCacheDTO>();

    this.cache.forEach((admissionIdAndHash: AdmissionIdAndHash, patientKey) => {
      const importDTO = new ImportCacheDTO(patientKey, admissionIdAndHash);
      temporaryCacheDTOArray.push(importDTO)
    });
    return temporaryCacheDTOArray;
  }

  public getCache(): ImportCache {
    const result: ImportCache = new Map();
    const stringSaved = JSON.parse(
      this.storage.getItem(this.STORAGE_ITEM_KEY) ?? '[]'
    ) as Array<ImportCacheDTO>;

    stringSaved.forEach((singleImport: ImportCacheDTO) => {
      result.set(singleImport.patientKey, singleImport.admissionIdAndHash);
    });
    return result;
  }
}
